import type { ComponentProps } from 'react';

import {
	FASTSHIFT_DC_ASSESSMENT_STATUSES,
	type FastshiftDcAssessmentStatus,
} from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import type Lozenge from '@atlaskit/lozenge';

import { messages } from './messages';

import type { MessageDescriptor } from 'react-intl';

type LozengeAppearance = NonNullable<ComponentProps<typeof Lozenge>['appearance']>;

const ASSESSMENT_STATUS_CONFIG: Record<
	FastshiftDcAssessmentStatus,
	{ appearance: LozengeAppearance; message: MessageDescriptor }
> = {
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.PENDING]: {
		appearance: 'neutral',
		message: messages.assessmentPending,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.IN_PROGRESS]: {
		appearance: 'information',
		message: messages.assessmentInProgress,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.UPDATING]: {
		appearance: 'information',
		message: messages.assessmentUpdating,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.UP_TO_DATE]: {
		appearance: 'success',
		message: messages.assessmentUpToDate,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.ACTION_REQUIRED]: {
		appearance: 'warning',
		message: messages.assessmentActionRequired,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.HAS_ERRORS]: {
		appearance: 'danger',
		message: messages.assessmentHasErrors,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.NO_DATA]: {
		appearance: 'neutral',
		message: messages.assessmentNoData,
	},
	[FASTSHIFT_DC_ASSESSMENT_STATUSES.OUTDATED]: {
		appearance: 'warning',
		message: messages.assessmentOutdated,
	},
};

const ASSESSMENT_NOT_AVAILABLE_CONFIG: {
	appearance: LozengeAppearance;
	message: MessageDescriptor;
} = {
	appearance: 'neutral',
	message: messages.assessmentNotAvailable,
};

export const getAssessmentStatusConfig = (status: string | null) =>
	status
		? (ASSESSMENT_STATUS_CONFIG[status as FastshiftDcAssessmentStatus] ??
			ASSESSMENT_NOT_AVAILABLE_CONFIG)
		: ASSESSMENT_NOT_AVAILABLE_CONFIG;
